import { ToastDomRef } from '@ui5/webcomponents-react';
import create from 'zustand';

interface ToastMessageStore {
  message: string;
  toastRef?: React.RefObject<ToastDomRef>;
  setToastRef: (value: React.RefObject<ToastDomRef>) => void;
  showToast: (message: string) => void;
}

const useGlobalToastMessageStore = create<ToastMessageStore>((set, get) => ({
  message: '',
  setToastRef: (value: React.RefObject<ToastDomRef>) => {
    set({ toastRef: value });
  },
  showToast: (message: string) => {
    const toastRef = get().toastRef;
    set({ message });

    if (toastRef && toastRef.current) {
      toastRef.current.show();
    }
  }
}));

export default useGlobalToastMessageStore;
